<template>
  <svg
    class="icon-svg"
    aria-hidden="true"
  >
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>

export default {
  name: 'IconSvg',
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconName: {
      get() {
        return `#icon-${this.name}`;
      },
    },
  },
};
</script>

<style>
.icon-svg {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>
